@import 'styles/mixins';
@import 'styles/variables';

.title {
  @include xxl-semibold;
  padding: 0;
  margin: 0 0 12px 0;
}

.description {
  @include lg-regular;
  margin-bottom: 28px;
}

.messageContainer {
  border: 1px solid $grey-10;
  border-radius: 6px;

  .toolbar {
    margin: 8px;
  }

  .message {
    @include lg-regular;
    margin: 8px 12px;

    &::placeholder {
      color: $grey-40;
    }
    :global(.ProseMirror) {
      min-height: 120px;
    }
  }
}
